import { BootstrapEffects } from './bootstrap.effects'
import { AuthEffects } from './auth.effects'

export * from './auth.effects'
export * from './bootstrap.effects'

export const effects: any[] = [AuthEffects, BootstrapEffects]
